// src/components/FloorPlanGenerator/Toolbar.js
import React from 'react';
import { elementTypes } from '../../constants/elementTypes';

const Toolbar = ({ currentType, setCurrentType, onSave, onClear, onAIGenerate }) => {
  return (
    <div className="toolbar">
      <div className="element-buttons">
        {elementTypes.map((type) => (
          <button
            key={type.name}
            onClick={() => setCurrentType(type.name)}
            className={`element-button ${currentType === type.name ? 'active' : ''}`}
            style={{ 
              backgroundColor: currentType === type.name ? type.color : '',
              borderColor: type.color
            }}
          >
            {type.name}
          </button>
        ))}
      </div>
      <div className="action-buttons">
        <button
          className="action-button"
          onClick={onAIGenerate}
          style={{ backgroundColor: '#4CAF50' }}
        >
          AI Generate
        </button>
        <button onClick={onSave} className="action-button">
          Save
        </button>
        <button onClick={onClear} className="action-button clear">
          Clear
        </button>
      </div>
    </div>
  );
};

export default Toolbar;
